import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BehaviorSubject, first, Observable, tap } from 'rxjs';
import { environment } from '@app/../environments/environment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Store } from '@ngrx/store';
import { selectProductsFilterTypeState } from '@app/modules/products/store/selectors/products.selectors';

@Injectable({
  providedIn: 'root'
})
export class ProductBarcodesService {
  public endpoint: string = environment.apiUrl + '/product-barcodes';
  private _data = new BehaviorSubject<any[]>([]);
  readonly barcodes = this._data.asObservable();
  constructor(
    private _http: HttpClient,
    private store$: Store,
    private _snackBar: MatSnackBar,
  ) { }

  createBarcode(barcode: any): Observable<any> {
    return this._http.post<any>(this.endpoint, barcode);
  }

  deleteBarcode(barcode): Observable<any> {
    return this._http.delete<any>(`${this.endpoint}/${barcode}`);
  }

  onAutoGenerate(res) {
    return this._http.get(`${environment.apiUrl}/product-barcodes/auto-generate`, {
      params: {
        checked: res
      }
    }).subscribe((res: any) => {

    });
  }

  onGenerateAvery(label, productIDs) {
    this.store$.select(selectProductsFilterTypeState).pipe(first()).pipe(tap((filterType) => {
      // switch (filterType) {
      //   case 'category':
      //     url = `${this.endpoint}/avery/categories/${categoryID}`;
      //     break;
      //   case 'area':
      //     url = `${this.endpoint}/avery/areas/${categoryID}`;
      //     break;
      // }
      let url = `${this.endpoint}/avery/products`;
      const idsString = productIDs.join(',');
      return this._http.get(url, {
        params: {
          label: label,
          productIDs: idsString,
        },
        responseType: 'blob'
      }).pipe(first()).subscribe((data: Blob) => {
        let pdf = new Blob([data], { type: 'application/pdf' });
        let url = URL.createObjectURL(pdf);
        window.open(url);
      });
    })).subscribe(res => {

    });
  }

  onGenerateD128Category(id, active, direction) {
    return this._http.get(`${environment.apiUrl}/products/d128/categories/${id}`, {
      responseType: 'blob',
      params:{
        active: active,
        direction: direction
      }
    }).pipe(first()).subscribe((data: Blob) => {
      let pdf = new Blob([data], { type: 'application/pdf' });
      let url = URL.createObjectURL(pdf);
      window.open(url);
    });
  }

  onGenerateD128Area(id, active, direction) {
    return this._http.get(`${environment.apiUrl}/products/d128/areas/${id}`, {
      responseType: 'blob',
      params:{
        active: active,
        direction: direction
      }
    }).pipe(first()).subscribe((data: Blob) => {
      let pdf = new Blob([data], { type: 'application/pdf' });
      let url = URL.createObjectURL(pdf);
      window.open(url);
    });
  }
  // `active`/`direction` mirror the column the list is sorted by, so the label
  // sheet comes out in the order the user is looking at instead of always by
  // product name.
  onGenerateD128Products(ids, active?: string, direction?: string) {
    const idsString = ids.join(',');
    let query = `productIDs=${idsString}`;
    if (active) {
      query += `&active=${encodeURIComponent(active)}&direction=${encodeURIComponent(direction || 'asc')}`;
    }
    const params = new HttpParams({
      fromString: query
    });
    return this._http.get(`${environment.apiUrl}/products/d128/products`, {
      responseType: 'blob',
      params
    }).pipe(first()).subscribe((data: Blob) => {
      let pdf = new Blob([data], { type: 'application/pdf' });
      let url = URL.createObjectURL(pdf);
      window.open(url);
    });
  }


  public validate(barcode):Observable<any>{
    return this._http.get(`${this.endpoint}/validate`, {
      params:{
        barcode
      }
    });
  }
}
